import { Heading, TextPassage } from '@petsmart-ui/sparky';

import type { FulfillmentMethod } from '../lib';
import './set-up-autoship.scss';

const DETAILS_TEXT: Record<FulfillmentMethod, string> = {
    bopis: 'Get your item for the first time by picking it up in store today or add it to the next Autoship order being shipped to you.',
    sdd: 'Get your item for the first time by having it delivered today or add it to the next Autoship order being shipped to you.',
    sth: 'Get your item for the first time by having it delivered in 1-3 days or add it to the next Autoship order being shipped to you.',
};

type SetUpAutoshipDetailsProps = Readonly<{
    fulfillmentMethod: FulfillmentMethod;
}>;

export const SetUpAutoshipDetails = ({ fulfillmentMethod }: SetUpAutoshipDetailsProps) => (
    <div className="set-up-autoship__details">
        <Heading tagName="h3" size="body-bold">
            Choose when you want your item
        </Heading>
        <TextPassage>{DETAILS_TEXT[fulfillmentMethod]}</TextPassage>
        <TextPassage>All future orders will be shipped to you.</TextPassage>
    </div>
);
